import  Dashboard from './Dashboard';

const Index = {
  Dashboard
};

export default Index;